<section class="loginpg-seccont">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 text-end"><img src="/assets/images/loign-img.png" class="img-fluid" /></div>
      <div class="col-md-6 align-self-center">
        <div class="text-center col-md-12 col-12"><img src="/assets/images/logo.png" class="img-fluid" /></div>
        <ng-container>
          <form [formGroup]="companyDomainForm">
            <div class="my-3 col-md-12 col-12 align-self-center">
              <label for="email" class="form-label">Company Domain</label>
              <input
                type="name"
                class="form-control"
                id="companyDomain"
                placeholder=""
                formControlName="companyDomain" />
            </div>
            <div class="text-center col-md-12 my-3 col-12">
              <button type="button" class="btnlogin" (click)="continue()">
                Continue <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </form>
        </ng-container>
      </div>
    </div>
  </div>
</section>
